<div class="ticket-outer-wrapper" id="ticket-outer-wrapper" style="height: 100%; background-color: white;" *ngIf="dataLoaded">
<!-- *ngIf="dataLoaded" -->
  <div class="flex justify-start">
    <div class="text-2xl">
      <ion-icon (click)="cerrarTicket()" class=" hover:text-red-500 mr-4 cursor-pointer" name="close-circle"></ion-icon>
    </div>
    <div class="text-2xl flex items-center">
      <oden-button icon="send" color="onlyIcon" classIcon="dark" class="mr-4"  (click)="sendTicket()"></oden-button>
    </div>
    <div class="text-2xl">
      <ion-icon (click)="print()" class=" hover:text-primary-500 cursor-pointer" name="print"></ion-icon>
    </div>

  </div>

  <div id="print-section">
    <div style="text-align: center;">
      <img style="height: 80px; width: 80px; border-radius: 100%; margin: auto;" src="{{user.gimnasio.logo}}" alt="">
    </div>
    <div style="text-align: center; font-size: 12px;">
      <p class="text-center">===================</p>
      <p class="text-center text-xl" style="font-size: 16px;">{{'REPORTS.TICKET.SALE_TICKET' | translate}}</p>
      <p class="text-center">===================</p>
      <!-- <p *ngIf="user.id_rol==3" class="text-center text-base" style="font-size: 14px;">{{user.gimnasio.nombre}}</p> -->
      <!-- <p *ngIf="user.id_rol!=3" class="text-center text-base" style="font-size: 14px;">{{user.sucursal?.nombre}}</p> -->
      <p class="text-center text-base" style="font-size: 14px;">{{dataBranch.nombre}}</p>
      <p class="text-center">===================</p>
      <div style="padding-right: 40px; padding-left: 40px;">
        <p>{{dataBranch.direccion.calle}}, {{dataBranch.direccion.colonia}}, {{dataBranch.direccion.num_ext}}, {{dataBranch.direccion.municipio}},
          {{dataBranch.direccion.estado}} {{dataBranch.direccion.codigo_postal}}, {{dataBranch.direccion.pais}}</p>

      </div>

      <p class="text-center mb-5">===================</p>
    </div>
    <div style=" padding-left: 10px; padding-right: 10px; font-size: 10px;">
      <table style="table-layout: fixed;">
        <tr>
          <th style="width: 40%;">{{'REPORTS.TICKET.CONCEPT' | translate}}</th>
          <th style="width: 10%;">{{'REPORTS.TICKET.QTY' | translate}}</th>
          <th style="width: 30%;"></th>
        </tr>
        <tr class="mb-3 border-b border-jet-black-200" *ngFor="let art of dataTicket.articulosTicket">
          <td style="width: 40%;">
            <p>
              {{art.nombre}} 
              <span *ngIf="art.varianteSelected.length > 0">
                {{art.varianteSelected[0].nombre}}
                <span *ngFor="let column of art.varianteSelected[0].columnas"> - {{column.valor}}</span>
              </span>
            </p>
            <p *ngIf="art.descuento > 0  && art.edited == false" style="font-style: italic;">
              {{'REPORTS.TICKET.DISCOUNT' | translate}}
            </p>
            <p *ngIf="art.accumulates_points == 1" style="font-style: italic;">
              {{'REPORTS.TICKET.WIN' | translate}}:
            </p>
            <p *ngIf="art.para_rentar == 1" style="font-style: italic;">
              {{'REPORTS.TICKET.FOR_RENT' | translate}}
            </p>
            <p *ngIf="art.para_rentar == 1" style="font-style: italic;">
              {{art.fecha_fin_renta | date:'dd/MM/yyyy'}}
            </p>
          </td>
          <td style="text-align: center; width: 10%;">{{art.cantidadBuy}}</td>
          <td style="text-align: right; width: 30%;">
            <p> {{user?.gimnasio.pais.abreviacion_divisa}}{{user?.gimnasio.pais.signo_divisa}}{{art.precioModificado}}
            </p>
            <p *ngIf="art.descuento > 0 && art.edited == false " style="font-style: italic;">
              {{user?.gimnasio.pais.abreviacion_divisa}}{{user?.gimnasio.pais.signo_divisa}}-{{art.descuento}}</p>
              <p *ngIf="art.accumulates_points == 1" style="font-style: italic;">{{art.points}} {{'REPORTS.TICKET.POINTS' | translate}}</p>
          </td>
        </tr>
        <tr class="mb-3 border-b border-jet-black-200" *ngFor="let mem of dataTicket.membresiasTicket">
          <td style="width: 40%;">
            <p> {{mem.nombre}} </p>
            <p *ngIf="mem.accumulates_points == 1" style="font-style: italic;"> {{'REPORTS.TICKET.WIN' | translate}}:</p>
          </td>
          <td style="text-align: center; width: 10%;">
            <p style="margin: 0px;">1</p>
          </td>
          <td style="text-align: right; width: 30%;">
            <p> {{user?.gimnasio.pais.abreviacion_divisa}}{{user?.gimnasio.pais.signo_divisa}}{{mem.costo_final}} </p>
            <p *ngIf="mem.accumulates_points == 1" style="font-style: italic;">{{mem.points}} {{'REPORTS.TICKET.POINTS' | translate}}</p>
          </td>
        </tr>
        <tr class="mb-3 border-b border-jet-black-200" *ngFor="let pts of dataTicket.puntos">
          <td style="width: 40%;">
            <p> {{'REPORTS.TICKET.POINTS' | translate}} </p>
          </td>
          <td style="text-align: center; width: 10%;">
            <p style="margin: 0px;"> {{ pts.puntos }}</p>
          </td>
          <td style="text-align: right; width: 30%;">
            <p> {{user?.gimnasio.pais.abreviacion_divisa}}{{user?.gimnasio.pais.signo_divisa}}{{
              formatPrecioPoints(pts.puntosFormat) }} </p>
          </td>
        </tr>
        <tr>
          <td style="width: 40%;">
            <p> Total: </p>
          </td>
          <td style="text-align: center; width: 10%;">
            <p style="margin: 0px;"> </p>
          </td>
          <td style="text-align: right; width: 30%;">
            <p> {{user?.gimnasio.pais.abreviacion_divisa}}{{user?.gimnasio.pais.signo_divisa}}{{ formatPrecioPoints(
              totalTicket) }} </p>
          </td>
        </tr>
      </table>
      <div style="font-weight: bold;">
        {{ dataTicket.numeroALetras(totalTicket,user.gimnasio.pais) }}
      </div>
        <p>{{'GLOBAL.TABLE_FIELD.PAYMENT_METHOD' | translate}}: <span style="font-weight: bold;">{{metodo_pago}}</span></p>
        <p *ngIf="dataTicket.sale_with_subscription" class="font-bold">{{'GLOBAL.TABLE_FIELD.SUBSCRIPTION' | translate}}: {{dataTicket.sale_with_subscription}}</p>
        <p style="font-weight: bold;">{{'GLOBAL.TABLE_FIELD.CLIENT' | translate}}: {{dataTicket.nombre}}</p>
    </div>
    <div style="text-align: center; font-size: 12px;">
      <p class="text-center">===================</p>
    </div>
    <div style="text-align: center; font-size: 12px;" *ngIf="dataTicket.fecha_compra">
      <p>{{dataTicket.fecha_compra}}</p>
    </div>
    <div style="text-align: center; font-size: 12px;" *ngIf="!dataTicket.fecha_compra">
      <p>{{ formatFecha() }}</p>
    </div>
    <div *ngIf="dataTicket.nombre != 'Sin asignar'" style="font-weight: bold;">
      <p>{{'GLOBAL.TABLE_FIELD.CLIENT' | translate}}: {{dataTicket.nombre}}</p>
 
    </div>
    <div style="text-align: center; font-size: 12px;">
      <img style="margin: auto; width: auto; height: 24mm;" src="../../../../assets/images/ticket-oden.png" alt="logo">
      <p>WWW.ODEN.MX</p>
    </div>
    <div style="text-align: center; font-size: 12px; font-style:normal;">
      <p>{{'REPORTS.TICKET.DOWNLOAD_OUR_APP' | translate}}</p>
      <img style="margin: auto; width: auto; height: 24mm;" src="../../../../assets/images/oden-qr.png" alt="Qr">
    </div>

  </div>
</div>
<!-- <button (click)="print()">print</button> -->